// extracted by mini-css-extract-plugin
export default {"content":"user_card__content__Psu2d"};